import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AccountStatus } from '@/interfaces/entities/user.account-status';
import { notificationService } from '@/services/notification.service';
import { userService } from '@/services/user.service';

const useUpdateUser = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({
			userId,
			status,
			message,
		}: {
			userId: number;
			status: AccountStatus;
			message: string;
		}) => await userService.changeApplicationRequest(userId, status, message),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['user'] });
		},

		onError: () => {
			notificationService.error('Error updating user');
			throw new Error('Error updating user');
		},
	});
};

export default useUpdateUser;
